<template>
  <v-container
    v-if="item"
    class="standard-page-width"
  >
    <v-row>
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12"
      >
        <v-card>
          <v-card-title>
            {{ $t('account') }}
          </v-card-title>
          <v-divider />
          <v-list>
            <v-list-item
              :to="{ name: 'account.details' }"
            >
              <v-list-item-title>
                {{ $t('details') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{ name: 'account.changePassword' }"
            >
              <v-list-item-title>
                {{ $t('change_password') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12"
      >
        <div
          :is="childComponent"
          :item="item"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '../store'
import { User } from '@serversgg/sdk-js'

export default {
  name: 'AccountView',

  props: {
    childComponent: {
      required: true,
      type: Function,
    },
  },

  data () {
    return {
      item: null,
    }
  },

  async beforeRouteEnter (to, from, next) {
    const item = await User
      .request()
      .find(store.state.auth.user.data.id)

    // eslint-disable-next-line no-return-assign
    next((vm) => {
      vm.item = item
    })
  },
}
</script>
